export default "__VITE_ASSET__BV9L4vmi__"